import React from 'react';
import AppModal from '.';
import { CircleAlert } from 'lucide-react';
import useUser from '@/redux/hooks/useUser';
import { Button, Flex } from 'antd';

function LogoutModal({ openModal, setOpenModal }) {
  const { logOut } = useUser();
  return (
    <AppModal
      open={openModal}
      onOk={logOut}
      onCancel={() => setOpenModal(false)}
      okText="Sign out"
      cancelText="Cancel"
      footer={false}
    >
      <div className="p-5 flex items-center flex-col gap-2">
        <CircleAlert color="#ff4d4f" size={48} />
        <h1 className="font-bold text-3xl">Sign out</h1>
        <p>Are you sure you want to sign out?</p>
      </div>

      <Flex align="center" justify="space-between" gap={10}>
        <Button
          onClick={() => setOpenModal(false)}
          className="flex-[50%] h-[40px] font-semibold"
          type="text"
        >
          Cancel
        </Button>
        <Button
          onClick={logOut}
          color="danger"
          variant="solid"
          className="flex-[50%] h-[40px] font-semibold"
        >
          Sign out
        </Button>
      </Flex>
    </AppModal>
  );
}

export default LogoutModal;
